import { render, staticRenderFns } from "./timeAdd.vue?vue&type=template&id=2afc146c&scoped=true&"
import script from "./timeAdd.vue?vue&type=script&lang=js&"
export * from "./timeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc146c",
  null
  
)

export default component.exports